exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1pdINh6c4O0RBawz8YAln5{width:100%}html[dir] ._1pdINh6c4O0RBawz8YAln5 .ocG6IWfJpV-L4TtLekVoS{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"container": "_1pdINh6c4O0RBawz8YAln5",
	"storageAccount": "ocG6IWfJpV-L4TtLekVoS"
};